import * as React from "react";
// import { pure } from 'recompose'

import * as Lodash from "lodash";
//  import *as Utils  from '@Cyclope-Utils/index';
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import CalendarIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as i18next from "i18next";

import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    selectedOptions,
    selectedValue,
    onGetValue,
    cameraString,
    style,
    camera,
    section,
    incident,
    cameraAndSection,
    vue,
    onSearchValue,
    error,
    isVisible,
    onMouseLeave,
    onMouseEnter,
    placeholder,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-custom-scrollbars
   * @infos "https://reactjs.org"
   */

  return (
    <Styled.Container onMouseLeave={onMouseLeave}>
      <Styled.ContainerBalise error={error}>
        <Styled.Input
          style={{ color: "#979797" }}
          onMouseEnter={onMouseEnter}
          onFocus={onMouseEnter}
          maxLength={50}
          autoComplete="OFF"
          type="text"
          onChange={onSearchValue}
          value={selectedValue}
          placeholder={placeholder}
          name="selectedValue"
        />
        <Styled.IconRotate
          onMouseEnter={onMouseEnter}
          rotates={!isVisible}
          style={{ width: "10px" }}
        >
          <CalendarIcon arrowSeek={true} color="#808fa3" />
        </Styled.IconRotate>
      </Styled.ContainerBalise>
      <Styled.BoxContainer isVisible={isVisible} style={style}>
        {!Lodash.isUndefined(selectedOptions) &&
          !Lodash.isEmpty(selectedOptions) && (
            <Scrollbars height="90px" width="100%">
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                camera &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={elem.id}
                  >
                    {elem.code}
                  </p>
                ))}
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                incident &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={elem.id}
                  >
                    {i18next.t(`${elem.label}`)}
                  </p>
                ))}
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                section &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={elem.id}
                  >
                    {elem.name}
                  </p>
                ))}
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                cameraAndSection &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={`${elem.id}-${elem.section && elem.section.id}`}
                  >
                    {elem.code}
                  </p>
                ))}
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                vue &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={elem}
                  >
                    {elem}
                  </p>
                ))}
              {Lodash.isArray(selectedOptions) &&
                selectedOptions &&
                cameraString &&
                selectedOptions.map((elem: any, index: number) => (
                  <p
                    className="text-Search"
                    onClick={onGetValue}
                    key={index}
                    id={elem}
                  >
                    {elem}
                  </p>
                ))}
            </Scrollbars>
          )}
        {Lodash.isUndefined(selectedOptions) && (
          <div className="searchLiveText">Aucun élement a été trouvé</div>
        )}
        {!Lodash.isUndefined(selectedOptions) &&
          Lodash.isEmpty(selectedOptions) && (
            <div className="searchLiveText">Aucun élement a été trouvé</div>
          )}
      </Styled.BoxContainer>
    </Styled.Container>
  );
};
// initialisation des props

Component.defaultProps = {
  selectedOptions: [],
  selectedValue: "",
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  selectedOptions: any;
  selectedValue: any;
  onGetValue: any;
  onSearchValue: any;
  isVisible: boolean;
  onMouseLeave: any;
  onMouseEnter: any;
  placeholder: string;
  error?: boolean;
  camera?: boolean;
  section?: boolean;
  incident?: boolean;
  cameraAndSection?: boolean;
  vue?: boolean;
  style?: any;
  cameraString?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/select/component.tsx